import React from 'react'
import { Link } from 'react-router-dom';
import CtaFive1 from "../../assets/images/shapes/cta-five-shape-1.png";
import CtaFive2 from "../../assets/images/shapes/cta-five-shape-2.png";
import TestimonialFourImg1 from "../../assets/images/testimonial/testimonial-four-detail-img-one.jpg";
import TestimonialFourImg2 from "../../assets/images/testimonial/testimonial-four-detail-img-two.jpg";

function CtaFive() {
  return (
    <div>
      <section className="cta-five">
        <div className="container-fluid">
          <div
            className="cta-four-shape-1 wow fadeInLeft animated"
            data-wow-duration="1500ms"
            data-wow-delay="100ms"
          >
            <div className="animation_image_zoom">
              <div className="cta-four-shape-1-img">
                <img
                  src={CtaFive1}
                  alt="cta-five-shape-1"
                />
              </div>
            </div>
          </div>
          <div
            className="cta-four-shape-2 wow fadeInRight animated"
            data-wow-duration="1500ms"
            data-wow-delay="100ms"
          >
            <div className="animation_image_zoom">
              <div className="cta-four-shape-2-img">
                <img
                  src={CtaFive2}
                  alt="cta-five-shape-2"
                />
              </div>
            </div>
          </div>
          <div className="container">
            <div className="cta-four-detail-box cta-five-detail-box">
              <div
                className="cta-four-detail-box-shape-1 wow fadeInLeft animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div className="animation_image_zoom">
                  <div className="cta-four-detail-box-shape-1-img">
                    <img
                      src={TestimonialFourImg1}
                      alt="testimonial-four-detail-img-one"
                    />
                  </div>
                </div>
              </div>
              <div
                className="cta-four-detail-box-shape-2 wow fadeInRight animated"
                data-wow-duration="1500ms"
                data-wow-delay="300ms"
              >
                <div className="animation_image_zoom">
                  <div className="cta-four-detail-box-shape-1-img">
                    <img
                      src={TestimonialFourImg2}
                      alt="testimonial-four-detail-img-two"
                    />
                  </div>
                </div>
              </div>
              <div className="cta-four-detail-box-shape-3" />
              <div className="cta-four-detail-box-shape-4" />
              <div className="section-five-title">
                <div
                  className="section-five-title-title text-center wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <h2>
                    Ready to Boost your <br /> Digital product marketing ?
                  </h2>
                </div>
                <div
                  className="section-five-details text-center wow fadeInUp animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <p>Approach focuses on capturing the essential</p>
                </div>
              </div>
              <div
                className="cta-four-btn text-center wow fadeInUp animated"
                data-wow-duration="1500ms"
                data-wow-delay="500ms"
              >
                <Link to="/contact" className="main-black-btn thm-btn">
                  Get Started
                  <i className="icon-right-arrow" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default CtaFive
